import { showField } from "../onboardingUtils"


export const getFinalOptions = (field, partnerListState) => {
        if(field?.value === "businessDetails.companyType"){
          return field?.options?.filter(item =>  {
            if(item?.notShow){
              return !showField(item?.notShow, partnerListState)
            }

            return item
          })
        }

        return field?.options
}